import $ from 'jquery';
import PassengerBaseClass from '../common/PassengerBaseClass';

/**
 * 宿泊者の部屋単体での管理
 */
export default class PassengerRoomClass extends PassengerBaseClass {
  constructor(_target, _index) {
    super(_target);
    this.name = 'PassengerRoomClass';

    this.EVENT_DELETE = 'eventdelete';

    this.maxNum = 8;

    this.isDelete = false;

    this.index = _index;

    this.onClickDeleteListener = this.onClickDelete.bind(this);
  }

  onCreate() {
    super.onCreate();

    this.ttl = $('.room_ttl', this.target);

    $('a', this.ttl).on('click', this.onClickDeleteListener);

    this.changeIndex(this.index);
    // ホテルとDPは、大人1人必要
    this.adult.minNum = 1;
  }

  onError() {
    this.jq.trigger(this.EVENT_ERROR, { msg: LtikeCommon.HOTEL.TEXT.MODAL_PASSENGER_ERROR4, index: this.index, target: this.target });
  }

  onClickDelete(e) {
    e.preventDefault();
    if (this.isDelete) { return false; }
    this.isDelete = true;
    this.target.remove();
    // console.log(this.name,"onClickDelete");
    this.jq.trigger(this.EVENT_DELETE, { index: this.index });
  }

  onChangeIndex(_i) {
    this.index = _i;
    this.changeIndex(this.index);
  }

  changeIndex(_i) {
    $('.text', this.ttl).text('部屋' + (_i + 1));
  }
}
